<template lang="pug">
  v-dialog(v-model="show" max-width="500" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable persistent)
    v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs" @click="snackBar = false")
          v-icon fas fa-times
    v-card
      v-card-title.headline(v-if="!selectedConfiguration") {{ $t('settingsPage.configuration.newConfigurationTitle') }}
      v-card-title.headline(v-else) {{ $t('settingsPage.configuration.updateConfiguration') }}
      v-card-text
        v-form(v-model="isFormValid" @submit.prevent="onSubmitButtonClick" ref="form" lazy-validation)
          v-row
            v-col(cols="12")
              v-text-field(outlined v-model="name" :label="$t('settingsPage.offerStructure.nameLabel')" autofocus :rules="nameRules")
          v-row
            v-col(cols="12")
              v-select(
                :items="businesses" v-model="selectedBusiness" label="Výdajné miesto" return-object outlined
                item-text="name" item-value="id" append-icon="fas fa-chevron-down"
                )
          v-row.ma-0.align-self-start
          v-select(
            max-height="112px"
            :items="tagList"
            :label="$t('settingsPage.labelLabel')"
            item-text="title"
            item-value="id"
            v-model="selectedTags"
            color="primary"
            multiple
            append-icon="fas fa-chevron-down"
            chips
            return-object
            outlined
            :rules="tagRules"
          )
            template( v-slot:selection="{ item, index }" )
              v-chip
                v-icon.mr-4(left) {{getIcon(item.iconClass)}}
                span {{item.title}}
            template(v-slot:item="{active, item, attrs, on }")
              v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                v-list-item-action
                  v-checkbox(
                    :input-value="active"
                    on-icon="fas fa-check-square"
                    off-icon="far fa-square" )
                v-list-item-content
                  v-list-item-title
                    v-icon.mr-4 {{getIcon(item.iconClass)}}
                    span {{item.title}}
          v-list(dense)
            v-row.ma-0
              v-checkbox.ma-0(
                v-model="ShowGroupsMandatory"
                on-icon="fas fa-check-square"
                off-icon="far fa-square" )
              span.pt-2 {{ $t('settingsPage.configuration.allowedLabel') }}
            v-row.ma-0
              v-checkbox.ma-0(
                v-model="ShowGroupsSingleItem"
                on-icon="fas fa-check-square"
                off-icon="far fa-square" )
              span.pt-2 {{ $t('settingsPage.configuration.singleFoodLabel') }}
            v-row.ma-0
              v-checkbox.ma-0(
                v-model="ShowGroupsPrice"
                on-icon="fas fa-check-square"
                off-icon="far fa-square" )
              span.pt-2 {{ $t('settingsPage.configuration.showPriceLabel') }}
          v-row(v-for="(timeBlock, idx) in timeBlocks" :key="idx")
            v-select(
              max-height="112px"
              :items="menuGroups"
              :label="timeBlock.title"
              item-text="title"
              item-value="id"
              v-model="groupsForTimeBlock[timeBlock.id]"
              color="primary"
              multiple
              append-icon="fas fa-chevron-down"
              chips
              return-object
              outlined
            )

      v-divider
      v-card-actions
        v-btn(v-if="selectedConfiguration" color="error" text @click="onDeleteButtonClick" :loading="isLoading" :disabled="loading") {{ $t('settingsPage.configuration.deleteButtonLabel') }}
        v-spacer
        v-btn( color="primary" text @click="onCancelButtonClick" :disabled="loading") {{ $t('optOutDialog.cancelButtonLabel') }}
        v-btn(color="primary" type="submit" :loading="loading" @click="onSubmitButtonClick" :disabled="!isFormValid && loading") {{$t('optOutDialog.submitCreditButtonLabel') }}

</template>

<script lang="ts">

import { Component, Prop, Watch } from 'vue-property-decorator'
import Vue from 'vue';
import Tag from "@/model/tennant/Tag";
import Configuration from "@/model/Configuration";
import i18n from "@/plugins/i18n";
import {
  FetchBoarderDetailPayload,
  NewSettingConfigurationPayload,
  UpdateSettingConfigurationPayload
} from "@/types/payload";
import {Action} from "vuex-class";
import {FETCH_BOARDER_DETAIL,} from "@/store/action-types";
import KeyList from "@/model/KeyList";
import {BoarderDetailResponse} from "@/types/service-response";
import BusinessModel from "@/model/menu/BusinessModel";
import {usePiniaStore} from "@/store/piniaStore";
import BusinessTimeBlockCollection from '@/model/business/BusinessTimeBlockCollection'
import MenuGroupList from '@/model/menu/MenuGroupList'

@Component({})

export default class AddNewConfigurationDialog extends Vue {
  $refs!: {
    form: Vue & {
      validate(): boolean,
      resetValidation(): boolean
    }
  }

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
  @Prop({ type: Boolean, default: false }) readonly isLoading!: boolean
  @Prop({ type: Array, default: false }) readonly configuration!: Configuration[]
  @Prop({ type: Array, required: true }) readonly keyList!: KeyList[]
  @Prop({ type: Array, default: false }) readonly tagList!: Tag[]
  @Prop({ type: Object, default: false }) readonly selectedConfiguration!: any
  @Prop({ type: Array, default: false }) readonly businesses!: BusinessModel[]
  @Action(FETCH_BOARDER_DETAIL) fetchBoarderDetails!: ({ (payload: FetchBoarderDetailPayload): Promise<BoarderDetailResponse> })

  private piniaStore = usePiniaStore()

  private isFormValid: boolean = false
  private name: string = ''
  private selectedTags: Tag[]  = []
  private selectedBusiness: BusinessModel|null = null
  private title:any[] = []
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''
  private nameRules: Array<(v:string) => string | boolean> = [
    (v:string) => !!v || i18n.t('settingsPage.offerStructure.nameValidationText').toString()
  ]
  private tagRules:Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('settingsPage.configuration.tagValidationText').toString()
  ]
  private ShowGroupsPrice: any = {
    key: 'configuration_group.show_price',
    value: false
  }
  private ShowGroupsMandatory: any = {
    key: 'configuration_group.is_mandatory',
    value: false
  }
  private ShowGroupsSingleItem: any = {
    key: 'configuration_group.single_item',
    value: false
  }

  private timeBlocks: BusinessTimeBlockCollection[] = []
  private menuGroups: MenuGroupList[] = []
  private groupsForTimeBlock: MenuGroupList[][] = []

  @Watch('selectedBusiness')
  async watchSelectedBusiness(newVal: BusinessModel|null): Promise<void> {
    if (newVal) {
      this.timeBlocks = await this.piniaStore.fetchTimeBlocks(newVal.id)
      const menuGroups = await this.piniaStore.fetchMenuGroups(newVal.id)
      this.menuGroups = menuGroups.filter((m: MenuGroupList) => m.isTopMenuGroup)

      if (this.selectedConfiguration?.settings.time_block_menu_group_link) {
        Object
          .keys(this.selectedConfiguration.settings.time_block_menu_group_link)
          .forEach((timeBlockId: any) => {
            let menuGroupIds =  this.selectedConfiguration.settings.time_block_menu_group_link[timeBlockId]
            let menuGroups = this.menuGroups.filter((group: MenuGroupList) => menuGroupIds.includes(group.id));

            this.groupsForTimeBlock[timeBlockId] = menuGroups;
          })
      }
    }
  }

  getIcon (item: string):string | null {
    if(item && item.length > 4) {
      return item  ? `fas ${item}` : null
    } else {
      return ''
    }
  }

  onSubmitButtonClick () {
    if(!this.selectedConfiguration) {
    let tagCollection: any = this.selectedTags.map((i: Tag) => {
      return `/api/tag/${i.id}`
    })
      let settingsData: any = {
        "configuration_group.is_mandatory": this.ShowGroupsMandatory,
        "configuration_group.single_item": this.ShowGroupsSingleItem,
        "configuration_group.show_price": this.ShowGroupsPrice,
        "time_block_menu_group_link": this._linkTimeBlockWithMenuGroup()
      }
    const payload1: NewSettingConfigurationPayload = {
      title: this.name,
      settings: settingsData,
      order: this.configuration.length + 1,
      business: this.selectedBusiness!.id.toString(),
      tags: tagCollection
    }
    this.createSettings(payload1)
  }else{
      let tagCollection: string[] = this.selectedTags.map((i: Tag) => {
        return `/api/tag/${i.id}`
      })

      let settingsData: any = {
        "configuration_group.is_mandatory": this.ShowGroupsMandatory,
        "configuration_group.single_item": this.ShowGroupsSingleItem,
        "configuration_group.show_price": this.ShowGroupsPrice,
        "time_block_menu_group_link": this._linkTimeBlockWithMenuGroup()
      }
      const payload2: UpdateSettingConfigurationPayload = {
        id: this.selectedConfiguration.id,
        title: this.name,
        settings: settingsData,
        order:this.selectedConfiguration.order,
        business: this.selectedBusiness!.id.toString(),
        tags: tagCollection
      }

      this.updateSelectedSettings(payload2)
    }

  }

  createSettings(payload: NewSettingConfigurationPayload){
    this.$emit('created', payload)
  }

  updateSelectedSettings(payload: UpdateSettingConfigurationPayload){
    this.$emit('updated', payload)

  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }

  onDeleteButtonClick (){
    const payload: any = this.selectedConfiguration.id
    this.$emit('delete', payload)
  }


  mounted() {
    if(this.selectedConfiguration) {
      this.name = this.selectedConfiguration.title
      this.selectedTags = this.selectedConfiguration.tags
      this.ShowGroupsMandatory = this.selectedConfiguration.settings['configuration_group.is_mandatory']
      this.ShowGroupsSingleItem = this.selectedConfiguration.settings['configuration_group.single_item']
      this.ShowGroupsPrice = this.selectedConfiguration.settings['configuration_group.show_price']
      this.selectedBusiness = this.selectedConfiguration.business
    }else{
      this.name = ''
      this.selectedTags = []
      this.ShowGroupsMandatory = false
      this.ShowGroupsSingleItem = false
      this.ShowGroupsPrice = false
    }
  }

  _linkTimeBlockWithMenuGroup(): any {
    let map: Record<string, any[]> = {};

    const timeBlockIds = Object.keys(this.groupsForTimeBlock);

    timeBlockIds.forEach((timeBlockId: any) => {
      const menuGroups = this.groupsForTimeBlock[timeBlockId] || [];
      for (const mm of menuGroups) {
        if (map[timeBlockId]) {
          map[timeBlockId].push(mm.id);
        } else {
          map[timeBlockId] = [mm.id];
        }
      }
    });

    return map;
  }

}

</script>

<style lang="stylus" scoped>

</style>
